export const getAdminEmails = () =>
  (process.env.REACT_APP_ADMIN_EMAIL || '')
    .split(',')
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

export const isAdminUser = (user) => {
  if (!user?.email) return false;
  const admins = getAdminEmails();
  if (admins.length === 0) return true;
  return admins.includes(user.email.toLowerCase());
};
